export class EnaioEventFoundText {
    clientEventId = "";
    wfEventId = "";
    eventName = "";
    text = "";
    position = 0;
    line = 0;
}
